import React from 'react';
import styled, { keyframes, StyledComponentClass } from 'styled-components';

import { colors } from '../../styles';

export type Speed = 'slow' | 'normal' | 'fast';
export type Size = 'sm' | 'md' | 'lg';

export interface Props {
  className?: string;
  size?: Size;
  speed?: Speed;
  color?: string;
}

const ACTUAL_SIZE = 34;
const sizeMap = {
  sm: 28,
  md: 46,
  lg: 64,
};

const speedMap = {
  slow: '1.5s',
  normal: '1s',
  fast: '0.5s',
};

class Spinner extends React.Component<Props> {
  public static defaultProps: Partial<Props> = {
    color: colors.green500,
    size: 'md',
  };

  public render() {
    const { className, color, size } = this.props;
    const sz = sizeMap[size];
    const scale = sz / ACTUAL_SIZE;
    return (
      <svg
        width={`${sz}px`}
        height={`${sz}px`}
        version="1.1"
        className={className}
      >
        <g>
          <path
            d="M4.95838735,5.00001791 C8.03641119,1.91138251 12.2949919,0 17,0 C21.7261835,0 26.0019123,1.92862605 29.0830999,5.04179175 L26.9617451,7.16314663 C24.4234809,4.59285833 20.8977565,3 17,3 C13.1234191,3 9.61483879,4.57559815 7.07971153,7.12134209 L4.95838735,5.00001791 Z"
            fill={color}
            opacity="0.25"
            transform={`scale(${scale})`}
          />
          <path
            d="M5.00003588,29.0416306 C8.07476912,32.1057909 12.3161764,34 17,34 C21.7050172,34 25.9636053,32.0886101 29.0416306,28.9999641 L26.9203064,26.8786399 C24.3851777,29.4243944 20.8765901,31 17,31 C13.1446036,31 9.65319673,29.4415753 7.12136007,26.9203064 L5.00003588,29.0416306 Z"
            fill={color}
            opacity="0.5"
            transform={`scale(${scale})`}
          />
          <path
            d="M5.02088692,29.0623742 C1.91999458,25.9827528 -1.05471187e-15,21.7155958 -1.05471187e-15,17 C-1.05471187e-15,12.2844042 1.91999458,8.01724722 5.02088692,4.9376258 L7.14222261,7.05896149 C4.58421645,9.59567625 3,13.1128313 3,17 C3,20.8871687 4.58421645,24.4043237 7.14222261,26.9410385 L5.02088692,29.0623742 Z"
            fill={color}
            opacity="0.75"
            transform={`scale(${scale})`}
          />
          <path
            d="M29.0416306,5.00003588 C32.1057909,8.07476912 34,12.3161764 34,17 C34,21.7050172 32.0886101,25.9636053 28.9999641,29.0416306 L26.8786399,26.9203064 C29.4243944,24.3851777 31,20.8765901 31,17 C31,13.1446036 29.4415753,9.65319673 26.9203064,7.12136007 L29.0416306,5.00003588 Z"
            fill={color}
            transform={`scale(${scale})`}
          />
        </g>
      </svg>
    );
  }
}

const rotate = keyframes`
  from {
    transform-origin: 50% 50%;
    transform: rotate(0deg);
  }
  to {
    transform-origin: 50% 50%;
    transform: rotate(360deg);
  }
`;

const StyledSpinner = styled(Spinner)`
  transform-origin: 0 0;
  g {
    animation: ${rotate}
      ${({ speed }: { speed: Speed }) => speedMap[speed || 'normal']} linear
      infinite;
  }
`;

export default StyledSpinner;
